module.exports = __webpack_public_path__ + "static/media/bvp_logo.3ad59b1a.jpeg";